import React, { useState } from 'react';
import { XIcon } from 'lucide-react'; // Import the XIcon here

import axios from 'axios';
import { ClipLoader } from 'react-spinners'; // Importing the spinner component

const ContactModal = ({ isOpen, onClose }) => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Track loading state
  const [isSuccess, setIsSuccess] = useState(null); // Track success/failure status
  const [errorMessage, setErrorMessage] = useState(""); // Store error message

  const handleSubmit = async () => {
    if (!message.trim() || !email.trim()) {
      alert("Please fill in both fields before submitting.");
      return;
    }

    setIsLoading(true); // Set loading state to true when the request starts
    setIsSuccess(null); // Reset success/failure state
    setErrorMessage(""); // Reset the error message

    try {
      console.log('the email,', email, 'message', message);
      // Use axios to send the POST request
      const response = await axios.post("https://trendhopper-c3934b7293e6.herokuapp.com/send_feedback_email/", {
        user_email: email,
        feedback: message,
      });

      if (response.status === 200) {
        setIsSuccess(true); // Mark success if the response is successful
      } else {
        throw new Error('Failed to submit message.');
      }
    } catch (error) {
      console.error("Error submitting message:", error);
      setIsSuccess(false); // Mark failure if there was an error
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false); // Set loading state to false when the request is done
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50">
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div className="relative w-full max-w-md rounded-xl border border-white/20 bg-black/40 backdrop-blur-xl p-6 shadow-lg">
          <button
            onClick={onClose}
            className="absolute right-4 top-4 rounded-full p-1 text-white/70 hover:text-white/90 hover:bg-white/10 transition-colors"
          >
            <XIcon className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </button>

          <h2 className="text-lg font-semibold text-white">Contact Us</h2>

          <div className="mt-4">
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 mb-4 rounded-lg border bg-white/10 text-white text-sm focus:ring-2 focus:ring-white/30"
            />
            <textarea
              placeholder="Your Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full p-2 rounded-lg border bg-white/10 text-white text-sm focus:ring-2 focus:ring-white/30"
            />
          </div>

          {/* Show loading spinner if request is in progress */}
          {isLoading && (
            <div className="flex justify-center items-center my-4">
              <ClipLoader color="#ffffff" size={50} />
            </div>
          )}

          {/* Show success or error message after request */}
          {isSuccess !== null && (
            <div className={`mt-4 text-center text-sm ${isSuccess ? 'text-green-500' : 'text-red-500'}`}>
              {isSuccess ? "Your message has been sent!" : errorMessage}
            </div>
          )}

          <div className="mt-6 flex justify-end gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg border border-white/20 bg-white/10 text-white/80 hover:bg-white/20 transition-all"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={isLoading || !message.trim() || !email.trim()}
              className="px-4 py-2 rounded-lg bg-white/20 text-white border border-white/30 hover:bg-white/30 transition-all text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Submit Message
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
